import { render, staticRenderFns } from "./DentalInsurance.vue?vue&type=template&id=b1348150&"
import script from "./DentalInsurance.vue?vue&type=script&lang=js&"
export * from "./DentalInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports